import React, { useState, useEffect } from "react";
import "./Home.css";
import Fade from "react-reveal/Fade";

import img1 from "./assets/7.png";
import img2 from "./assets/8.png";
import img3 from "./assets/2.png";
import img4 from "./assets/6.png";

export const Home = () => {

  /* =====================================================
     SERVICES
  ===================================================== */

  const services = [
    "בניית אתרים",
    "פרסום באינטרנט",
    "קידום ברשתות חברתיות",
    "קידום בגוגל",
    "קידום אורגני",
    "שיווק דיגיטלי",
    "מיתוג עסקי",
  ];

  /* =====================================================
     INFO CARDS
  ===================================================== */

  const cards = [

    {
      img: img1,
      title: "למה העסק שלך צריך אתר אינטרנט?",
      text:
        "כאשר לקוח מחפש שירות או מוצר, אחד המקומות הראשונים שאליהם הוא פונה הוא Google. אתר מקצועי מאפשר לעסק שלך להיות נוכח בדיוק ברגע שבו לקוח פוטנציאלי מחפש את השירות שאתה מספק. האתר הוא המקום שבו הלקוח יכול להכיר את העסק, להבין מה אתם מציעים, לראות עבודות, לקבל מידע וליצור קשר.",
    },

    {
      img: img2,
      title: "איך אתר יכול לעזור להביא לקוחות?",
      text:
        "אתר טוב הוא הרבה מעבר לעיצוב יפה. הוא צריך להציג את העסק בצורה ברורה, ליצור אמון ולהוביל את המבקר לפעולה. טלפון, WhatsApp, טופס יצירת קשר, הצגת השירותים והמלצות — כל אלה יכולים להפוך ביקור באתר להזדמנות עסקית. המטרה היא ליצור חוויית משתמש שמקלה על הלקוח לקבל החלטה ולפנות אליכם.",
    },

    {
      img: img4,
      title: "קידום בגוגל והגדלת החשיפה",
      text:
        "בניית האתר היא רק חלק מהנוכחות הדיגיטלית. חשוב שהאתר יהיה בנוי בצורה נכונה גם עבור מנועי חיפוש. מבנה עמודים נכון, כותרות, תוכן איכותי, התאמה למובייל, מהירות טעינה ואלמנטים טכניים נוספים יוצרים בסיס טוב לקידום אורגני. קידום בגוגל הוא תהליך מתמשך, והמטרה היא להגיע לאורך זמן לקהל שמחפש את השירותים של העסק.",
    },

    {
      img: img3,
      title: "איזה סוג אתר מתאים לעסק?",
      text:
        "לכל עסק יש צרכים שונים. יש עסקים שעבורם אתר תדמית מקצועי יספיק, עסקים שזקוקים לדף נחיתה ממוקד, ויש עסקים שצריכים אתר גדול יותר עם מספר רב של עמודים או חנות אינטרנטית. אנחנו מתאימים את מבנה האתר למטרות העסק, לשירותים שהוא מציע ולקהל שאליו הוא פונה — ולא מוסיפים רכיבים מיותרים רק כדי להגדיל את המחיר.",
    },

  ];

  /* =====================================================
     TYPING EFFECT
  ===================================================== */

  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {

    const current = services[index % services.length];

    const speed = deleting ? 60 : 110;

    const timer = setTimeout(() => {

      if (!deleting) {

        setText(
          current.substring(0, text.length + 1)
        );

        if (text === current) {

          setTimeout(() => {
            setDeleting(true);
          }, 1000);

        }

      } else {

        setText(
          current.substring(0, text.length - 1)
        );

        if (text === "") {

          setDeleting(false);

          setIndex((prev) => prev + 1);

        }

      }

    }, speed);

    return () => clearTimeout(timer);

  }, [text, deleting, index]);


  return (

    <div className="home-wrapper">


      {/* =================================================
          HERO / TYPING
      ================================================= */}

      <section className="home-hero">

        <div className="hero-content">

    

          <h1>
            האתר שלך הוא הרבה יותר
            <br />

            <span>
               מכרטיס ביקור
            </span>
          </h1>

          <p className="hero-description">

            אנחנו בונים אתרי אינטרנט מקצועיים שמציגים
            את העסק שלך בצורה נכונה, מחזקים את המותג
            ויוצרים בסיס לחשיפה, שיווק וקבלת פניות מלקוחות.

          </p>


          <div className="typing-area">

            <h4>
              מה אנחנו עושים?
            </h4>

            <div className="typing-box">

              {text}

              <span className="cursor">
                |
              </span>

            </div>

          </div>

        </div>

      </section>


      {/* =================================================
          INTRO
      ================================================= */}

      <section className="home-intro">

        <Fade bottom>

          <div className="home-intro-content">

            <span className="section-label">
              הנוכחות הדיגיטלית שלך
            </span>

            <h2>
              להפוך את האתר שלך
              <br />
              <span>
                לכלי שמשרת את העסק
              </span>
            </h2>

            <p>
              היום לקוחות לא מסתפקים רק במספר טלפון.
              לפני שהם יוצרים קשר, הם רוצים להכיר את העסק,
              לראות מי עומד מאחוריו, להבין אילו שירותים הוא
              מספק ולקבל תחושת ביטחון.
            </p>

            <p>
              אתר מקצועי מאפשר לך להציג את העסק שלך
              24 שעות ביממה, לספק מידע ללקוחות חדשים,
              להציג את השירותים והעבודות שלך ולתת ללקוח
              דרך פשוטה ומהירה ליצור איתך קשר.
            </p>

          </div>

        </Fade>

      </section>


      {/* =================================================
          CARDS
      ================================================= */}

      <section className="info-list">

        {cards.map((card, i) => (

          <Fade
            bottom
            key={i}
          >

            <article className="info-row">

              <div className="info-img">

                <img
                  src={card.img}
                  alt={card.title}
                  loading="lazy"
                />

              </div>


              <div className="info-text">

                <span className="info-number">
                  {String(i + 1).padStart(2, "0")}
                </span>

                <h3>
                  {card.title}
                </h3>

                <p>
                  {card.text}
                </p>

              </div>

            </article>

          </Fade>

        ))}

      </section>


      {/* =================================================
          GOOGLE / SEO
      ================================================= */}

      <section className="seo-section">

        <Fade bottom>

          <div className="seo-content">

            <span className="section-label">
              GOOGLE • SEO • DIGITAL
            </span>

            <h2>
              רוצים שיותר לקוחות
              <br />
              <span>
                ימצאו את העסק שלכם?
              </span>
            </h2>

            <p>
              נוכחות בגוגל יכולה להיות חלק משמעותי
              מהשיווק של עסק. כאשר אנשים מחפשים שירות
              מסוים, הם רוצים למצוא עסק שנראה מקצועי,
              אמין ורלוונטי עבורם.
            </p>

            <p>
              לכן אנחנו לא מסתכלים רק על איך האתר נראה.
              אנחנו חושבים גם על המבנה שלו, על התוכן,
              על חוויית המשתמש, על התאמה למובייל ועל
              הבסיס הטכני הנדרש לעבודה עם SEO.
            </p>

            <p>
              חשוב לזכור: קידום אורגני בגוגל הוא תהליך
              ולא פעולה חד־פעמית. אתר איכותי הוא הבסיס,
              ועליו ניתן לבנות תהליך של תוכן, אופטימיזציה
              ושיווק לאורך זמן.
            </p>

          </div>

        </Fade>

      </section>


      {/* =================================================
          CUSTOMER JOURNEY
      ================================================= */}

      <section className="customer-section">

        <div className="customer-title">

          <span className="section-label">
            הדרך מלקוח פוטנציאלי ללקוח
          </span>

          <h2>
            איך אתר טוב יכול
            <span>
              לעבוד בשביל העסק?
            </span>
          </h2>

        </div>


        <div className="customer-flow">

          <div className="customer-step">

            <div className="step-icon">
              🔍
            </div>

            <span>
              01
            </span>

            <h3>
              הלקוח מחפש
            </h3>

            <p>
              הלקוח מחפש בגוגל שירות או מוצר
              שהעסק שלך מספק.
            </p>

          </div>


          <div className="flow-arrow">
            ←
          </div>


          <div className="customer-step">

            <div className="step-icon">
              🌐
            </div>

            <span>
              02
            </span>

            <h3>
              הלקוח נכנס לאתר
            </h3>

            <p>
              הוא מקבל מידע ברור ומכיר את העסק,
              השירותים והיתרונות שלכם.
            </p>

          </div>


          <div className="flow-arrow">
            ←
          </div>


          <div className="customer-step">

            <div className="step-icon">
              ⭐
            </div>

            <span>
              03
            </span>

            <h3>
              נוצר אמון
            </h3>

            <p>
              עיצוב מקצועי, תוכן, תמונות והצגת
              עבודות מחזקים את הרושם על העסק.
            </p>

          </div>


          <div className="flow-arrow">
            ←
          </div>


          <div className="customer-step">

            <div className="step-icon">
              📞
            </div>

            <span>
              04
            </span>

            <h3>
              יוצרים קשר
            </h3>

            <p>
              הלקוח יכול להתקשר, לשלוח WhatsApp
              או להשאיר פרטים.
            </p>

          </div>

        </div>

      </section>


      {/* =================================================
          WHY US
      ================================================= */}

      <section className="why-section">

        <Fade bottom>

          <div className="why-content">

            <span className="section-label">
              SITE B2B
            </span>

            <h2>
              לא רק אתר.
              <br />
              <span>
                נוכחות דיגיטלית לעסק.
              </span>
            </h2>

            <p>
              אנחנו משלבים עיצוב, פיתוח, חוויית משתמש
              וחשיבה שיווקית כדי ליצור אתר שמתאים
              לעסק ולמטרות שלו.
            </p>

            <p>
              אנחנו מאמינים שאתר טוב צריך להיות ברור,
              מהיר, נוח, מקצועי ובעיקר כזה שהלקוח מבין
              ממנו מי אתם ומה אתם יכולים להציע לו.
            </p>

            <div className="why-points">

              <div>
                ✓ עיצוב בהתאמה אישית
              </div>

              <div>
                ✓ התאמה מלאה למובייל
              </div>

              <div>
                ✓ מבנה ידידותי למנועי חיפוש
              </div>

              <div>
                ✓ מהירות וביצועים
              </div>

              <div>
                ✓ חוויית משתמש
              </div>

              <div>
                ✓ חשיבה על יצירת פניות
              </div>

            </div>

          </div>

        </Fade>

      </section>


      {/* =================================================
          FINAL CTA
      ================================================= */}

      <section className="home-cta">

        <Fade bottom>

          <div>

            <span className="section-label">
              הגיע הזמן להתקדם
            </span>

            <h2>
              העסק שלך צריך אתר
              <br />
              <span>
                שעובד בשבילך
              </span>
            </h2>

            <p>
              נוכחות דיגיטלית מקצועית יכולה לעזור לעסק
              להציג את עצמו טוב יותר, להגיע לקהל חדש
              ולתת ללקוחות דרך פשוטה ליצור קשר.
            </p>

          </div>

        </Fade>

      </section>


    </div>

  );
};